import { render, staticRenderFns } from "./DeleteIconRequest.vue?vue&type=template&id=17f38556&scoped=true&"
import script from "./DeleteIconRequest.vue?vue&type=script&lang=js&"
export * from "./DeleteIconRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f38556",
  null
  
)

export default component.exports